import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import InputPhoto from './input_upload';
import { useAppDispatch, RootState } from '@/store';
import { addPhoto, deletePhoto, getPhotos } from '@/store/photo/action';
import BreadcrumbLayout from '@/components/common/CustomLayout/BreadcrumbLayout';
import { ReactComponent as RiDeleteBin } from '@/assets/icons/ri-delete-bin-6-line.svg'
import Button from '@/components/common/Button';
import 'react-datepicker/dist/react-datepicker.css'

const renderExistingPhotos = (
  existingPhotos: Photo[],
  deleteExistingPhoto: Function
) => (
  existingPhotos.map(photo => (
    <div className="border border-grey-line-subtle w-[300px] h-[250px] rounded px-4 py-2">
        <div className="flex pb-2">
          <p className="grow text-jsm font-normal text-grey-darkoverflow-hidden">
              {photo.title}
          </p>
          <div className="flex-none">
            <Button className="text-red-primary flex items-center p-0 hover:cursor-pointer"
                    variant='tertierry'
                    onClick={() => deleteExistingPhoto(photo)}>
              <RiDeleteBin/>
            </Button>
          </div>
        </div>
        <img
          src={photo.src}
          alt=""
          className="rounded overflow-hidden h-[150px] w-[300px] object-cover"
        />
        <p className="grow text-jsm font-normal text-grey-dark my-2 h-[42px] overflow-y-scroll" >
          {photo.description !== "" ? photo.description : "-"}
        </p>
    </div>
  ))
)

const Photos = () => {
  const dispatch = useAppDispatch()
  const photoState = useSelector((state: RootState) => state.photo.state)
  const [existingPhotos, setExistingPhotos] = useState([])
	const [file, setFile] = useState<File | null>(null);

  const deleteExistingPhoto = async (photo: Photo) => {
    await dispatch(deletePhoto(photo.id))
    await dispatch(getPhotos())
  }

  const submitPhoto = async (photo: PhotoPayload) => {
    await dispatch(addPhoto(photo)).then(() => setFile(null))
    await dispatch(getPhotos())
  }

  useEffect(() => {
    (async () => {
      await dispatch(getPhotos())
    })()
    setExistingPhotos([...photoState])
  }, [])

  useEffect(() => {
    setExistingPhotos([...photoState])
  }, [dispatch, getPhotos, photoState])

  return (
    <BreadcrumbLayout>
      <div className='flex flex-col w-full gap-8'>
        <div className='flex flex-col p-0'>
          <div className='flex flex-col gap-2 p-7 bg-white'>
            <p className='font-bold text-lg'>
                Add Photo
            </p>
            <div className='pl-4'>
              <InputPhoto file={file} setFile={setFile} onSubmit={submitPhoto}/>
            </div>
          </div>
          <div className='flex flex-col gap-2 p-7 bg-white'>
            <p className='font-bold text-lg'>
              Photos
            </p>
            <div className='grid grid-flow-col p-4 auto-cols-max gap-4'>
              {renderExistingPhotos(existingPhotos, deleteExistingPhoto)}
            </div>
          </div>
        </div>
      </div>
    </BreadcrumbLayout>
  );
}

export default Photos
